import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { SourceNamesManager } from '../../../components/source-names'
import { SourceNamesLoader } from '../../../components/source-names/source-names-loader'

function Bridge({ organizationID }) {
  if (typeof organizationID !== 'string') {
    throw new Error('organizationID is required')
  }
  return (
    <SourceNamesLoader organizationID={organizationID}>
      {({ sourceNames, loading, refetch }) => {
        return (
          <SourceNamesManager
            loading={loading}
            refetch={refetch}
            organizationID={organizationID}
            sourceNames={sourceNames}
          />
        )
      }}
    </SourceNamesLoader>
  )
}

export const reactSourceNamesManager = createNgReactBridgeDirective(
  'reactSourceNamesManager',
  [],
  Bridge,
  ['organizationID']
)
